<app-page-wrapper
  [useHeader]="true"
  [useBackBtn]="true"
  [useFooter]="true"
  [title]="title"
  [subtitle]="subtitle"
>

  <ion-content>
    <div class="step-online-credit" *ngIf="loaded$ | async">
      <div class="form-wrapper" *ngIf='!isFinalRequest'>
        <app-payment-form
                [formFieldsList]="userFormFiled"
                [formGroup]="userFormGroup"
                [readOnly]="true"
        >
        </app-payment-form>
      </div>
      <div class="additional-form">
        <div class="form-wrapper">
          <app-payment-form
                  [formGroup]="addressFormGroup"
                  [formFieldsList]="additionalFormField.address"
                  [readOnly]="true"
          >
          </app-payment-form>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Сведения о ранее выданных паспортах <span
                  style="font-size: 12px;">( образца 1997 года )</span></div>
          <div class="form-row">
            <app-payment-form
                    [formGroup]="prevDocFormGroup"
                    [formFieldsList]="additionalFormField.prevDock"
                    [readOnly]="true"
            >
            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Данные о месте работы</div>
          <div class="new-online-credit-form__column">
            <app-payment-form
                    [formGroup]="employerFormGroup"
                    [formFieldsList]="additionalFormField.employer"
                    [readOnly]="true"
            >
            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Стаж работы на последнем месте</div>
          <div class="new-online-credit-form__column">
            <app-payment-form
                    [formGroup]="workExperienceFormGroup"
                    [formFieldsList]="additionalFormField.work"
                    [readOnly]="true"
            >
            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper">
          <div class="form-title">Данные о семейном положении</div>
          <div class="new-online-credit-form__column">
            <app-payment-form
                    [formGroup]="maritalFormGroup"
                    [formFieldsList]="additionalFormField.marital"
                    [readOnly]="true"
            >
            </app-payment-form>
          </div>
        </div>
        <div class="form-wrapper" [formGroup]="rulesFormGroup">
          <app-form-checkbox
                  formControlName="agreeRules"
                  [option]="agreeRules.title"
                  [disable]="true"
                  [textData]="agreeRules.text"
          ></app-form-checkbox>

          <app-form-checkbox
                  formControlName="agreeInsurance"
                  [option]="agreeInsurance.title"
                  [disable]="true"
                  [textData]="agreeInsurance.text"
          ></app-form-checkbox>


          <app-form-checkbox
                  formControlName="agreeDebt"
                  [option]="agreeDebt.title"
                  [disable]="true"
                  [textData]="agreeDebt.text"
          ></app-form-checkbox>
        </div>
      </div>

      <div class="client-credits" *ngIf="groupCredits$ | async as groupCredits">
        <div class="client-credits-group" *ngFor="let group of groupCredits">
          <div class="form-title">
            {{ group.type }}
          </div>
          <div class="client-credits__credit" *ngFor="let activeCredit of group.credits">
            <div class="credit__info">
              Дата получения:
              <span class="credit__info-value">
              {{ activeCredit.openDate | date }}
            </span>
            </div>
            <div class="credit__info">
              Сумма:
              <span class="credit__info-value">
              {{ activeCredit.creditLimit | amount }}
            </span>
            </div>
            <div class="credit__info">
              Валюта:
              <span class="credit__info-value">
              {{ activeCredit.creditCurrency }}
            </span>
            </div>
            <div class="credit__info" *ngIf="activeCredit.monthAmount">
              Ежемесячный платеж:
              <span class="credit__info-value">
              {{ activeCredit.monthAmount | amount }}
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loaded$ | async">
    <ion-button expand="block" class="button block primary" ripple-effect (click)="confirm()">
      Подтвердить
    </ion-button>
    <ion-button expand="block" class="button block primary-light" (click)="showBlank()" *ngIf="isFinalRequest">
      Просмотреть анкету
    </ion-button>
    <ion-button expand="block"
                class="button primary-light"
                ripple-effect
                (click)="abort()"
    >
      Отмена
    </ion-button>
  </ng-container>
</app-page-wrapper>


<!-- </app-page> -->
